import { TFunction } from 'i18next'
import React, { FC, useContext } from 'react'
import { AppContext } from '../../../../../../contexts/AppContext'
import BadgeSwiper from '../../../../../../modals/badges/components/BadgeSwiper'
import { BadgeHook } from '../../../../hooks/useBadges'
import { TierData } from '../../../../types/tierData'

interface BadgesCategoryListProps {
	swiperData: Record<string, { tiers: TierData[]; categoryName: string }>
	badgeHook: BadgeHook
	onSeeAll: (tiers: TierData[], categoryName: string) => void
	t: TFunction<'pages_saving', 'badgesCard'>
}

const BadgesCategoryList: FC<BadgesCategoryListProps> = ({
	swiperData,
	badgeHook,
	onSeeAll,
	t,
}) => {
	const { isDarkMode } = useContext(AppContext)

	return (
		<div className='flex flex-col gap-4'>
			{Object.entries(swiperData).map(([category, { tiers, categoryName }]) => (
				<div key={category}>
					<div className='flex justify-between items-center mb-3 px-6'>
						<h3 className='text-lg font-semibold capitalize text-text-dark dark:text-white tracking-wide'>
							{categoryName}
						</h3>
						<span
							className='text-center text-base cursor-pointer text-brand-secondary-100-light dark:text-brand-primary-100-dark tracking-wide font-semibold'
							onClick={() => onSeeAll(tiers, categoryName)}
						>
							{t('viewAll')}
						</span>
					</div>
					<BadgeSwiper
						tiers={tiers}
						color={isDarkMode ? '#0d2d30' : '#ffffff'}
						isLoading={badgeHook.isLoading}
					/>
				</div>
			))}
		</div>
	)
}

export default BadgesCategoryList
